import { LoaderService } from './loader.service';

export {
    LoaderService
}